import { render } from "./DotsLoader.vue?vue&type=template&id=7cb3679c&scoped=true"
const script = {}

import "./DotsLoader.vue?vue&type=style&index=0&id=7cb3679c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb3679c"]])

export default __exports__